import { CapacityPlanGeocodeStatus } from 'core/graphql/types';

export interface GeocodeStatusBadgeProps {
  status: CapacityPlanGeocodeStatus;
}

const labels: { [key in CapacityPlanGeocodeStatus]: string } = {
  [CapacityPlanGeocodeStatus.NotNeeded]: 'Not needed',
  [CapacityPlanGeocodeStatus.Pending]: 'Pending',
  [CapacityPlanGeocodeStatus.Geocoded]: 'Geocoded',
  [CapacityPlanGeocodeStatus.Failed]: 'Failed',
  [CapacityPlanGeocodeStatus.Manual]: 'Manual',
};

const colours: { [key in CapacityPlanGeocodeStatus]: string } = {
  [CapacityPlanGeocodeStatus.NotNeeded]: 'bg-gray text-design-black',
  [CapacityPlanGeocodeStatus.Pending]: 'bg-yellow text-design-black',
  [CapacityPlanGeocodeStatus.Geocoded]: 'bg-design-green text-design-black',
  [CapacityPlanGeocodeStatus.Failed]: 'bg-darker-red text-white',
  [CapacityPlanGeocodeStatus.Manual]: 'bg-bright-blue text-white',
};

/** Geocode Status of one uploaded Delivery, as the Deliveries tab shows it. */
const GeocodeStatusBadge = ({ status }: GeocodeStatusBadgeProps) => (
  <span
    aria-label="Geocode status"
    className={`whitespace-nowrap rounded-sm px-2 py-1 text-xs font-semibold uppercase ${colours[status]}`}
  >
    {labels[status]}
  </span>
);

export default GeocodeStatusBadge;
